import VueRouter from 'vue-router'
import Vue from 'vue'
import buy from '../components/view/buy'
import download from '../components/view/download'
import featurepack from '../components/view/featurepack_new'
import about from '../components/view/about'
import home from '../components/view/home'
import service from '../components/view/service'
import gardenfirst from '../components/view/gardenfirst'
import garden from '../components/view/garden'
import invest from '../components/view/invest'
import stock from '../components/view/stock'
import stats from '../components/view/stats'
import news from '../components/view/news'
import success from '../components/view/success'
Vue.use(VueRouter)
const routes = [

  {
    path: "/home",
    component: home,
    name: "home",

  },
  {
    path: "/gardenfirst",
    component: gardenfirst,
    name: "gardenfirst",

  },
  {
    path: "/garden",
    component: garden,
    name: "garden",

  },
  {
    path: "/buy",
    component: buy,
    name: "buy"
  },
  {
    path: "/download",
    component: download,
    name: "download"
  },
  {
    path: "/news",
    component: news,
    name: "news"
  },

  {
    path: "/service",
    component: service,
    name: "service"
  },
  {
    path: "/featurepack/:id",
    component: featurepack,
    name: "featurepack"
  },
  {
    path: "/invest/:id",
    component: invest,
    name: "invest"
  },
  {
    path: "/stock/:id",
    component: stock,
    name: "stock"
  },
  {
    path: "/stats/:id",
    component: stats,
    name: "stats"
  },
  {
    path: "/about",
    component: about,
    name: "about"
  },
  // {
  //   path: "/download_dzb",
  //   component: download_dzb,
  //   name: "download_dzb"
  // },
  {
    path: "/success",
    component: success,
    name: "success"
  },
  {
    path: '*',
    redirect: '/home'
  }


]

const router = new VueRouter({
  mode: 'hash',

  routes
})
export default router